import { render, staticRenderFns } from "./ColorPickerComponent.vue?vue&type=template&id=b69d8edc&"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js&"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports